export const Brand_Cards = [
  {
    id: 1,
    mainImg: 'https://image.onstove.com/630x489/d2x8kymwjom7h7.cloudfront.net/live/application_no/10009/iop-center-front/indie_3%EB%8B%A8%EC%B9%B4%EB%93%9C_C%ED%83%80%EC%9E%85_%EC%9D%B4%EB%AF%B8%EC%A7%80%EB%B0%B0%EB%84%88_Plug-in-digital_1726130612564.png',
    title: 'Plug In Digital',
    description: 'Your games everywhere'
  },
  {
    id: 2,
    mainImg: 'https://image.onstove.com/630x489/d2x8kymwjom7h7.cloudfront.net/live/application_no/10009/iop-center-front/indie_3%EB%8B%A8%EC%B9%B4%EB%93%9C_C%ED%83%80%EC%9E%85_%EC%9D%B4%EB%AF%B8%EC%A7%80%EB%B0%B0%EB%84%88_Plug-in-digital_1726130612564.png',
    title: '어둠 포착',
    description: '그 날의 온도, 그 날의 우리'
  },
  {
    id: 3,
    mainImg: 'https://image.onstove.com/630x489/d2x8kymwjom7h7.cloudfront.net/live/application_no/10009/iop-center-front/indie_3%EB%8B%A8%EC%B9%B4%EB%93%9C_C%ED%83%80%EC%9E%85_%EC%9D%B4%EB%AF%B8%EC%A7%80%EB%B0%B0%EB%84%88_Plug-in-digital_1726130612564.png',
    title: '메이플리워',
    description: '박스와 함께하는 대단한 모험'
  },
  {
    id: 4,
    mainImg: 'https://image.onstove.com/630x489/d2x8kymwjom7h7.cloudfront.net/live/application_no/10009/iop-center-front/indie_3%EB%8B%A8%EC%B9%B4%EB%93%9C_C%ED%83%80%EC%9E%85_%EC%9D%B4%EB%AF%B8%EC%A7%80%EB%B0%B0%EB%84%88_Plug-in-digital_1726130612564.png',
    title: '505 Games',
    description: '다채로운 장르의 게임 퍼블리셔'
  },
  {
    id: 5,
    mainImg: 'https://image.onstove.com/630x489/d2x8kymwjom7h7.cloudfront.net/live/application_no/10009/iop-center-front/indie_3%EB%8B%A8%EC%B9%B4%EB%93%9C_C%ED%83%80%EC%9E%85_%EC%9D%B4%EB%AF%B8%EC%A7%80%EB%B0%B0%EB%84%88_Plug-in-digital_1726130612564.png',
    title: '유진 게임즈',
    description: '감성 넘치는 다양한 게임 제작'
  },
  {
    id: 6,
    mainImg: 'https://image.onstove.com/630x489/d2x8kymwjom7h7.cloudfront.net/live/application_no/10009/iop-center-front/indie_3%EB%8B%A8%EC%B9%B4%EB%93%9C_C%ED%83%80%EC%9E%85_%EC%9D%B4%EB%AF%B8%EC%A7%80%EB%B0%B0%EB%84%88_Plug-in-digital_1726130612564.png',
    title: 'INDIE.IO',
    description: '인디의 힘이 게임을 이끈다'
  },
  {
    id: 7,
    mainImg: 'https://image.onstove.com/630x489/d2x8kymwjom7h7.cloudfront.net/live/application_no/10009/iop-center-front/indie_3%EB%8B%A8%EC%B9%B4%EB%93%9C_C%ED%83%80%EC%9E%85_%EC%9D%B4%EB%AF%B8%EC%A7%80%EB%B0%B0%EB%84%88_Plug-in-digital_1726130612564.png',
    title: '에스테라스',
    description: '여성향 로맨틱 판타지 웹툰'
  },
  {
    id: 8,
    mainImg: 'https://image.onstove.com/630x489/d2x8kymwjom7h7.cloudfront.net/live/application_no/10009/iop-center-front/indie_3%EB%8B%A8%EC%B9%B4%EB%93%9C_C%ED%83%80%EC%9E%85_%EC%9D%B4%EB%AF%B8%EC%A7%80%EB%B0%B0%EB%84%88_Plug-in-digital_1726130612564.png',
    title: '이그노스트',
    description: '최고의 비주얼 RPG 게임'
  },
  {
    id: 9,
    mainImg: 'https://image.onstove.com/630x489/d2x8kymwjom7h7.cloudfront.net/live/application_no/10009/iop-center-front/indie_3%EB%8B%A8%EC%B9%B4%EB%93%9C_C%ED%83%80%EC%9E%85_%EC%9D%B4%EB%AF%B8%EC%A7%80%EB%B0%B0%EB%84%88_Plug-in-digital_1726130612564.png',
    title: '테일조샵',
    description: '감성적인 캐릭터 커스터마이징'
  },
  {
    id: 10,
    mainImg: 'https://image.onstove.com/630x489/d2x8kymwjom7h7.cloudfront.net/live/application_no/10009/iop-center-front/indie_3%EB%8B%A8%EC%B9%B4%EB%93%9C_C%ED%83%80%EC%9E%85_%EC%9D%B4%EB%AF%B8%EC%A7%80%EB%B0%B0%EB%84%88_Plug-in-digital_1726130612564.png',
    title: '엔박스 게임즈',
    description: '신나는 새로운 게임과 모험'
  },
  {
    id: 11,
    mainImg: 'https://image.onstove.com/630x489/d2x8kymwjom7h7.cloudfront.net/live/application_no/10009/iop-center-front/indie_3%EB%8B%A8%EC%B9%B4%EB%93%9C_C%ED%83%80%EC%9E%85_%EC%9D%B4%EB%AF%B8%EC%A7%80%EB%B0%B0%EB%84%88_Plug-in-digital_1726130612564.png',
    title: 'STUDIO GAVI',
    description: '새로운 상상력과 모험의 세계로'
  },
  {
    id: 12,
    mainImg: 'https://image.onstove.com/630x489/d2x8kymwjom7h7.cloudfront.net/live/application_no/10009/iop-center-front/indie_3%EB%8B%A8%EC%B9%B4%EB%93%9C_C%ED%83%80%EC%9E%85_%EC%9D%B4%EB%AF%B8%EC%A7%80%EB%B0%B0%EB%84%88_Plug-in-digital_1726130612564.png',
    title: '게임즈 헤븐',
    description: '게임 천국으로의 초대'
  }
];

export const Brand_Cards_articles = [
  {
    id: 1,
    mainImg: 'https://cnitsstudio-api.com:570/uploads/products/97/Pumpkin_Table_Set.png',
    title: 'Plug In Digital',
    description: '다양한 인디 게임을 제공하는 디지털 퍼블리셔.',
    price: '₩ 8,900',
    tags: ['인디', '퍼블리셔', '게임'],
    recommend: 3
  },
  {
    id: 2,
    mainImg: 'https://cnitsstudio-api.com:570/uploads/products/97/Pumpkin_Table_Set.png',
    title: '505 GAMES',
    description: '다양한 플랫폼을 지원하는 글로벌 게임 퍼블리셔.',
    price: '₩ 18,900',
    tags: ['액션', '퍼블리셔', '게임'],
    recommend: 5
  },
  {
    id: 3,
    mainImg: 'https://cnitsstudio-api.com:570/uploads/products/97/Pumpkin_Table_Set.png',
    title: '에니코나',
    description: '독창적인 그래픽과 스토리라인이 특징인 개발사.',
    price: '₩ 12,500',
    tags: ['그래픽', '스토리', 'RPG'],
    recommend: 4
  },
  {
    id: 4,
    mainImg: 'https://cnitsstudio-api.com:570/uploads/products/97/Pumpkin_Table_Set.png',
    title: '어그노스트',
    description: '서스펜스와 스릴 넘치는 어드벤처 게임 개발사.',
    price: '₩ 20,500',
    tags: ['어드벤처', '서스펜스'],
    recommend: 6
  },
  {
    id: 5,
    mainImg: 'https://cnitsstudio-api.com:570/uploads/products/97/Pumpkin_Table_Set.png',
    title: '팀업북팀업북팀업북팀업북팀업북팀업북',
    description: '팀 기반 전략 게임 전문 개발사.',
    price: '₩ 25,000',
    tags: ['전략', '멀티플레이', '팀게임'],
    recommend: 2
  },
  {
    id: 6,
    mainImg: 'https://cnitsstudio-api.com:570/uploads/products/97/Pumpkin_Table_Set.png',
    title: '팀업북팀업북팀업북팀업북팀업북팀업북',
    description: '팀 기반 전략 게임 전문 개발사.',
    price: '₩ 25,000',
    tags: ['전략', '멀티플레이', '팀게임'],
    recommend: 2
  },
];

export const Brand_bottom_Cards = [
  {
    id: 1,
    mainImg: 'https://cnitsstudio-api.com:570/uploads/products/97/Pumpkin_Table_Set.png',
    title: 'Plug In Digital',
    description: '다양한 인디 게임을 제공하는 디지털 퍼블리셔.',
    price: '₩ 8,900',
    tags: ['인디', '퍼블리셔', '게임'],
    recommend: 3
  },
  {
    id: 2,
    mainImg: 'https://cnitsstudio-api.com:570/uploads/products/97/Pumpkin_Table_Set.png',
    title: '505 GAMES',
    description: '다양한 플랫폼을 지원하는 글로벌 게임 퍼블리셔.',
    price: '₩ 18,900',
    tags: ['액션', '퍼블리셔', '게임'],
    recommend: 5
  },
  {
    id: 3,
    mainImg: 'https://cnitsstudio-api.com:570/uploads/products/97/Pumpkin_Table_Set.png',
    title: '에니코나',
    description: '독창적인 그래픽과 스토리라인이 특징인 개발사.',
    price: '₩ 12,500',
    tags: ['그래픽', '스토리', 'RPG'],
    recommend: 4
  },
  {
    id: 4,
    mainImg: 'https://cnitsstudio-api.com:570/uploads/products/97/Pumpkin_Table_Set.png',
    title: '어그노스트',
    description: '서스펜스와 스릴 넘치는 어드벤처 게임 개발사.',
    price: '₩ 20,500',
    tags: ['어드벤처', '서스펜스'],
    recommend: 6
  },
  {
    id: 5,
    mainImg: 'https://cnitsstudio-api.com:570/uploads/products/97/Pumpkin_Table_Set.png',
    title: '팀업북팀업북팀업북팀업북팀업북팀업북',
    description: '팀 기반 전략 게임 전문 개발사.',
    price: '₩ 25,000',
    tags: ['전략', '멀티플레이', '팀게임'],
    recommend: 2
  },
];
